import { useState } from 'react'

/**
 * Bump key que se mete en el queryKey para forzar a TanStack Query a
 * re-fetchear SIN usar cache. Necesario para el botón "Refrescar" de
 * las pages (wallet, mining, skills, industry, tax, etc.) — sin esto,
 * si la query ya está en cache, useQuery no la refresca aunque el
 * caller se lo pida.
 *
 * Antes cada page tenía su propio `const [force, setForce] = useState(0)`
 * duplicado y todas metían `force` en api.*(...). Con este hook centralizamos
 * el patrón y queda trivial moverlo a invalidación real cuando se necesite.
 *
 * Uso:
 *   const { data, isFetching } = useQuery({
 *     queryKey: ['mining', forceRefetchKey],
 *     queryFn: () => api.miningLedger(forceRefetchKey > 0),
 *   })
 *   <button onClick={bump}>Refrescar</button>
 */
export function useForceRefetch() {
  const [key, setKey] = useState(0)
  return {
    /** Incluir en el queryKey. 0 = nada forzado aún. */
    key,
    /** Boolean conveniente para pasarle al api.*() como `force`. */
    force: key > 0,
    /** Llamar desde el botón "Refrescar". */
    bump: () => setKey((k) => k + 1),
  }
}
